import SimpleBarReact from "simplebar-react";
import {styled} from "@mui/system";

const SimpleBarReactStyled = styled(SimpleBarReact)(({theme}) => ({
    "& .simplebar-track .simplebar-scrollbar:before": {
        backgroundColor: theme.palette.info.main,
    },
    "@media print": {
        overflow: "visible !important",
        height: "100% !important",
        maxHeight: "none !important",
        "& .simplebar-content-wrapper": {
            overflow: "visible !important",
            height: "auto !important",
        },
        "& .simplebar-mask": {
            overflow: "visible !important",
        },
        "& .simplebar-track": {
            display: "none !important",
        },
        "& .simplebar-placeholder": {
            height: "0 !important",
        },
    },
    // "& .simplebar-content-wrapper": {
    //   minHeight: "900px",
    // }
}));

export default SimpleBarReactStyled;
